import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../../types";
import { Node } from "./types";
import { transformMetadata, processTimestampFields } from "../../../utils";

export type NodeOnSnapshotCollectionService<T> = (
  workflowId: string,
  versionId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: NodeOnSnapshotCollectionService<EntityGet<Node>> = (
  workflowId,
  versionId,
  opts: ListServiceOpts,
  callback,
  onError = () => {}
) => {
  const collectionRef = collection(
    db,
    `/workflow/${workflowId}/version/${versionId}/node`
  );
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Node>,
                doc.metadata
              )
            ) as EntityGet<Node>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
